import { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import styles from './GoogleAIPrompts.module.scss';

const cx = classnames.bind(styles);
const CN = 'google-ai-prompts';

export const GoogleAIPrompts: React.FC = () => {
  const [ isClient, setIsClient ] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  return <google-ai-prompts direction='horizontal' limit='3' className={ cx(CN) } />;
};
